import { I18nComponente } from "@/types/gerais"

export const OTabelaUsuariosInativosi18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    codigo: "código",
    pesquisarPorNomeDoUsuario: "pesquisar por nome do usuário",
    pesquisarPorCodigo: "pesquisar por código",
    limpar: "Limpar",
    aplicar: "Aplicar",
    ativar: "ativar",
    umUsuarioAtivadoNaoPoderaMaisSerUtilizado: "um usuário ativado poderá ser utilizado novamente para acessar o sistema",
  },
  "es-CO": {
    nome: "nombre",
    codigo: "código",
    pesquisarPorNomeDoUsuario: "buscar por nombre de usuario",
    pesquisarPorCodigo: "buscar por código",
    limpar: "Borrar",
    aplicar: "Aplicar",
    ativar: "activar",
    umUsuarioAtivadoNaoPoderaMaisSerUtilizado: "un usuario activado podrá ser utilizado nuevamente para acceder al sistema",
  }
}
